
import React, { useEffect } from "react";
import Navbar from "@/components/Navbar";
import Hero from "@/components/Hero";
import WhyParticipate from "@/components/WhyParticipate";
import ParticipationCriteria from "@/components/ParticipationCriteria";
import Timing from "@/components/Timing";
import OurTracks from "@/components/OurTracks";
import OurMentors from "@/components/OurMentors";
import Mission from "@/components/Mission";
import FAQ from "@/components/FAQ";
import Footer from "@/components/Footer";

const Index = () => {
  // Initialize intersection observer to detect when elements enter viewport
  // Defer to improve FCP
  useEffect(() => {
    const setupObserver = () => {
      const observer = new IntersectionObserver(
        (entries) => {
          entries.forEach((entry) => {
            if (entry.isIntersecting) {
              entry.target.classList.add("animate-fade-in");
              observer.unobserve(entry.target);
            }
          });
        },
        { threshold: 0.1 }
      );
      
      const elements = document.querySelectorAll(".animate-on-scroll");
      elements.forEach((el) => observer.observe(el));
      
      return () => {
        elements.forEach((el) => observer.unobserve(el));
      };
    };

    // Defer non-critical observer setup to improve FCP
    const timeoutId = setTimeout(setupObserver, 100);
    return () => clearTimeout(timeoutId);
  }, []);

  useEffect(() => {
    // Defer smooth scrolling setup to improve FCP
    const setupSmoothScroll = () => {
      // Enhanced smooth scrolling for anchor links using offsetTop to avoid forced reflow
      document.querySelectorAll('a[href^="#"]').forEach(anchor => {
        anchor.addEventListener('click', function (e) {
          e.preventDefault();
          
          const targetId = this.getAttribute('href')?.substring(1);
          if (!targetId) return;
          
          const targetElement = document.getElementById(targetId);
          if (!targetElement) {
            console.error(`Element with id "${targetId}" not found`);
            return;
          }
          
          // Use offsetTop instead of getBoundingClientRect to avoid forced reflow
          const offsetPosition = targetElement.offsetTop - 80; // Account for fixed navbar
          
          window.scrollTo({
            top: offsetPosition,
            behavior: 'smooth'
          });
        });
      });
    };

    // Defer non-critical smooth scroll setup to improve FCP
    const timeoutId = setTimeout(setupSmoothScroll, 0);
    return () => clearTimeout(timeoutId);
  }, []);

  useEffect(() => {
    const scrollToHash = () => {
      const hash = decodeURIComponent(window.location.hash.replace('#', ''));
      if (!hash) return;
      const el = document.getElementById(hash);
      if (el) {
        // Use offsetTop instead of getBoundingClientRect to avoid forced reflow
        const top = el.offsetTop - 80; // Account for fixed navbar
        window.scrollTo({ top, behavior: 'smooth' });
      }
    };
    scrollToHash();
    window.addEventListener('hashchange', scrollToHash);
    return () => window.removeEventListener('hashchange', scrollToHash);
  }, []);

  return (
    <div className="min-h-screen">
      <Navbar />
      <main className="space-y-4 sm:space-y-8">
        <Hero />
        <WhyParticipate />
        <ParticipationCriteria />
        <Timing />
        <OurTracks />
        <OurMentors />
        <Mission />
        <FAQ />
      </main>
      <Footer />
    </div>
  );
};

export default Index;
